import '../assets/NcKbd-8TOrFNAw.css';
import { defineComponent, computed } from "vue";
import { r as register, x as t7, a as t } from "./_l10n-DmTbp_o_.mjs";
import { i as isMac } from "./platform-CC2ecGvV.mjs";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-DU4iP6Vu.mjs";
register(t7);
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcKbd",
  props: {
    symbol: { default: void 0 },
    mac: { type: [Boolean, null], default: isMac }
  },
  setup(__props) {
    const props = __props;
    const labels = computed(() => ({
      ArrowUp: "↑",
      ArrowDown: "↓",
      ArrowLeft: "←",
      ArrowRight: "→",
      Control: !props.mac ? t("Ctrl") : "⌘",
      Alt: !props.mac ? t("Alt") : "⌥",
      Shift: !props.mac ? t("Shift") : "⇧",
      Enter: !props.mac ? t("Enter") : "⏎",
      Tab: !props.mac ? t("Tab") : "⇥",
      Delete: !props.mac ? t("Delete") : "⌫",
      Escape: !props.mac ? t("Escape") : "⎋",
      Space: t("Space")
      // TRANSLATORS: Space key on keyboard
    }));
    const label = computed(() => props.symbol && labels.value[props.symbol] || props.symbol);
    return { __sfc: true, props, labels, label };
  }
});
const kbd = "_kbd_nUCxj";
const style0 = {
  "material-design-icon": "_material-design-icon_tnSQy",
  kbd
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("kbd", { class: _vm.$style.kbd }, [_vm._t("default", function() {
    return [_vm._v(" " + _vm._s(_setup.label) + " ")];
  })], 2);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles,
  null
);
const NcKbd = __component__.exports;
export {
  NcKbd as N
};
//# sourceMappingURL=NcKbd-B32hSsfO.mjs.map
